import { CountryInfo } from "@/api/SolarCloudApi";

type CountrySpec = string | string[] | CountryInfo | CountryInfo[];

export const extractCountryCodes = (
  countrySpec?: CountrySpec
): string[] | undefined => {
  if (!countrySpec) {
    return [];
  }

  if (Array.isArray(countrySpec)) {
    return countrySpec.map((item) => {
      if (typeof item === "string") {
        return item;
      } else {
        return (item as CountryInfo).code!;
      }
    });
  } else {
    if (typeof countrySpec === "string") {
      return [countrySpec];
    } else {
      return [(countrySpec as CountryInfo).code!];
    }
  }
};
